document.addEventListener('DOMContentLoaded', () => {
  window.dataLayer = window.dataLayer || [];

  window.add_related_product = function () {
    dataLayer.push({'event': 'add related product'});
  }

  window.add_to_wishlist = function () {
    dataLayer.push({'event': 'add to wishlist'});
  }

  window.subscribe_newsletter = function () {
    dataLayer.push({'event': 'subscribe newsletter'});
  }
});
